exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ColorPickerModal-colorBg-299PJ{\n  background: #fff;\n  text-align: center;\n  color: #212121;\n}", "", {"version":3,"sources":["/home/gitlab-runner/builds/6LM1fF8ya/0/asap-lombok/asap-super-delivery/superdelivery-web-v1.3.2/src/components/SiteAdmin/DeliveryModule/ColorPickerModal/ColorPickerModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;CAChB","file":"ColorPickerModal.css","sourcesContent":[".colorBg{\n  background: #fff;\n  text-align: center;\n  color: #212121;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"colorBg": "ColorPickerModal-colorBg-299PJ"
};